<template>
	<FullPageLoader v-if="status.fetchUser.loading" />
	<div v-if="isUserAgeIsLegal">
		<Header
			v-if="!status.fetchUser.loading && localLatLngExist && !showFullScreen"
		/>
		<Chat v-if="!status.fetchUser.loading && localLatLngExist" />
		<router-view v-if="!status.fetchUser.loading && localLatLngExist" />
		<Landing
			v-if="!status.fetchUser.loading && !localLatLngExist && !showFullScreen"
		/>
	</div>
	<AgeCheckModal v-if="!isUserAgeIsLegal" />
</template>

<script>
	import Header from "./components/Header/Header.vue";
	import FullPageLoader from "./components/Loaders/FullPageLoader.vue";
	import Landing from "./views/Landing.vue";
	import AgeCheckModal from "./components/Modals/AgeCheckModal.vue";
	import {mapGetters, mapActions} from "vuex";
	import Chat from "./views/Chat.vue";

	export default {
		components: {Header, FullPageLoader, Landing, AgeCheckModal, Chat},

		computed: {
			...mapGetters("auth", ["status", "isLoggedIn", "user", "location_var"]),
			...mapGetters("cat", ["getCategories"]),
		},
		methods: {
			...mapActions("auth", ["fetchUser"]),
			...mapActions("cart", ["fetchCart"]),
			...mapActions("cat", ["fetchCategories"]),
		},
		data() {
			return {
				loading: true,
				localLatLngExist: false,
				showFullScreen: true,
				isError: false,
				isUserAgeIsLegal: false,
			};
		},
		mounted() {
			if (!localStorage.getItem("location")) {
				localStorage.setItem(
					"location",
					JSON.stringify({lat: 28.5270978, lng: 77.3922024})
				);
			}
			let getLocalLegalAge =
				process.env.VUE_APP_SHOW_AGE_MODAL == "true"
					? localStorage.getItem("age")
					: true;
			if (getLocalLegalAge) {
				this.isUserAgeIsLegal = true;
				this.showFullScreen = false;
			}
			let getLocalLatLng = localStorage.getItem("location");
			if (getLocalLatLng) {
				this.localLatLngExist = true;
				this.showFullScreen = false;
			}
			if (getLocalLegalAge && getLocalLatLng) {
				this.fetchUser();
				this.fetchCart();
				this.fetchCategories();
				console.log("fetching User, Fetching Carts, Fetching Categories");
			}
			console.log("App.vue Mounted");
		},
		watch: {
			$route(to, from) {
				if (to.fullPath == "/404") {
					this.showFullScreen = true;
				}
			},
		},
	};
</script>
<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.1s ease;
	}
	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
	}
</style>
